import { render } from "./AppNotFound.vue?vue&type=template&id=56296c15&scoped=true"
import script from "./AppNotFound.vue?vue&type=script&lang=js"
export * from "./AppNotFound.vue?vue&type=script&lang=js"

import "./AppNotFound.vue?vue&type=style&index=0&id=56296c15&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56296c15"]])

export default __exports__